(function() {
    fpConstants = fp.constants = {
        matchMediaMin: {XS: 10, SM: 768, MD: 992, LG: 1200},
        matchMediaMax: {XS_MAX: 767, SM_MAX: 991, MD_MAX: 1199, LG_MAX: 9999},
        matchContainerMin: {XS:10, SM: 720, MD: 940, LG: 1140},
        matchContainerMax: {XS_MAX: 719, SM_MAX: 939, MD_MAX: 1139, LG_MAX: 9999},
        //matchContainerMin: {XS:10, SM: 700, MD: 900, LG: 1100},
        //matchContainerMax: {XS_MAX: 699, SM_MAX: 899, MD_MAX: 1099, LG_MAX: 9999},
        //matchContainerMin: {XS: 10, SM: 768, MD: 992, LG: 1200},
        //matchContainerMax: {XS_MAX: 767, SM_MAX: 991, MD_MAX: 1199, LG_MAX: 9999},
        NEW_ITEM_PREFIX: 'new-',
        pager: {
            MAX_SIZE: 9, //maximum number of pages to display in list
            ITEMS_PER_PAGE: 20 //maximum number of page items to display
        },
        httpStatus: {
            OK: 200,
            BAD_REQUEST: 400,
            UNAUTHORIZED: 401,
            NOT_FOUND: 404,
            INTERNAL_SERVER_ERROR: 500,
            NOT_IMPLEMENTED: 501,
            SERVICE_UNAVAILABLE: 503,
            GATEWAY_TIMEOUT: 504
        },
        mode: {
            TEST: 'test'
        },
        listItemChangeType: {
            ADD: 1,
            UPDATE: 2,
            REMOVE: 3,
            INCREMENT: 4,
            CHECK_TOGGLE: 5,
            SUBSCRIPTION: 6,
            UPDATE_VARIETY: 7
        },
        keycode: {
            TAB: 9,
            ENTER: 13,
            RETURN: 13,
            ESC: 27,
            SPACE: 32,
            END: 35,
            HOME: 36,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            BACKSPACE: 8,
            DELETE: 46
        },
        apiMethods: {
            GET: 'GET',
            POST: 'POST',
            PUT: 'PUT',
            DELETE: 'DELETE',
            PUBLISH: 'PUBLISH'
        },
        api: {
            TIMEOUT: 59000
        },
        progress: {
            DELAY: 200
        },
        priority: {
            CRITICAL: 1,
            MAJOR: 2,
            MINOR: 3,
            TRIVIAL: 4
        },
        //these constants need to be converted to be dynamically generated by API calls,
        adminRole: {
            ADMIN: 'admin', //14693
            TESTER: 'tester', //14698

            ORDER_ADMIN: 'order_admin', //14694
            REPORT_VIEWER: 'report_viewer', //14694
            ORDER_VIEWER: 'order_viewer', //411241
            INSIGHTS_VIEWER: 'insights_viewer', //1586821
            PERSONAL_SHOPPER: 'personal_shopper', //14695
            USER_ADMIN: 'user_admin', //14701
            PRODUCT_ADMIN: 'product_admin', //14702
            REVIEW_ADMIN: 'review_admin', //1530615
            RECIPE_ADMIN: 'recipe_admin', //264321
            BUNDLE_ADMIN: 'bundle_admin', //267757
            CIRCULAR_ADMIN: 'circular_admin', //14703
            OFFER_ADMIN: 'offer_admin', //14704
            STORE_ADMIN: 'store_admin', //14705
            SPC_ADMIN: 'spc_admin',
            DEPARTMENT_ADMIN: 'department_admin',
            SCOPE_ADMIN: 'scope_admin',
            CLIENT_ADMIN: 'client_admin',
            EMAIL_TEMPLATE_ADMIN: 'email_template_admin',
            TAG_ADMIN: 'tag_admin', //14708
            TAG_TYPE_ADMIN: 'tag_type_admin', //14709
            APP_ADMIN: 'app_admin', //14873
            EVERYONE: 'everyone', //14835
            ADVERTISER_ADMIN: 'advertiser', //1572141
            DISABILITY_ACCOMMODATION: 'disability_accommodation', //22405010
            DEVELOPER_ONLY: 'developer_only',
            SUPPORT: 'support'
        },
        errorCode: {
            INVALID_INPUT: 'invalid_input',
            NOT_AUTHORIZED: 'not_authorized',
            INVALID_OPERATION: 'invalid_operation',
            PAYMENT_REQUIRED: 'payment_required',
            FULFILLMENT_SLOT_REQUIRED: 'fulfillment_slot_required',
            ORDER_MISMATCH: 'order_mismatch',
            STORE_CARD_REQUIRED: 'store_card_required',
            STORE_CARD_INVALID: 'store_card_invalid',
            SIGN_IN_REQUIRED: 'sign_in_required',
            SIGN_OUT_REQUIRED: 'sign_out_required',
            SERVER_ERROR: 'server_error'
        },
        cardFieldStatus: {
            HIDE: 'hide',
            SHOW: 'show',
            REQUIRED: 'required',
            OPTIONAL: 'optional',
            PARTIAL: 'partial',
            DISPLAY_ONLY: 'display_only'
        },
        rewardTypes: {
            OFFERS: 'offers',
            POINTS: 'points',
            GIFTS: 'gifts'
        },
        customAttributeTypes: {
            RADIO: 'radio',
            CHECKBOX: 'checkbox',
            DROPDOWN: 'dropdown',
            USER_ENTERED: 'user_entered',
            TEXT: 'text',
            TEXT_MULTILINE: 'text_multiline'
        },
        varietyTypes: {
            RADIO: 'radio',
            CHECKBOX: 'checkbox',
            DROPDOWN: 'dropdown'
        },
        ordinal: {
            0: 'th',
            1: 'st',
            2: 'nd',
            3: 'rd'
        },
        freshopCalendar: {
            START: '2014-01-01',
            FINISH: '2099-01-01'
        },
        barcodeFormat: {
            upc_a: 'UPC',
            upca: 'UPC',
            upc: 'UPC',
            code_39: 'CODE39',
            code39: 'CODE39',
            code_128: 'CODE128',
            code128: 'CODE128',
            ean_13: 'EAN13',
            ean13: 'EAN13',
            qr_code: 'QrCode'

        },
        trackingEvents: {
            AddToCart: {event: 'AddToCart', ecommerceEvent: 'add_to_cart', label: 'Add To Cart', category: 'Product', ecommerceOnly: true},
            AddToFavorites: {event: 'AddToFavorites', label: 'Add To Favorites', category: 'Product'},
            AddToMyRecipes: {event: 'AddToMyRecipes', label: 'Add To My Recipes', category: 'Recipe'},
            ClickedRecommendation: {event: 'ClickedRecommendation', label: 'Clicked Recommendation', category: 'Product'},
            CheckoutStep: {event: 'CheckoutStep', label: 'Checkout Step', category: 'Navigation', ecommerceOnly: true},
            DeliveryCheck: {event: 'DeliveryCheck', label: 'Delivery Check', category: 'Store'},
            DownloadPDF: {event: 'DownloadPDF', label: 'Download PDF', category: 'Download'},
            EmailList: {event: 'EmailList', label: 'Email List', category: 'Email'},
            InitiateCheckout: {event: 'InitiateCheckout', label: 'Initiate Checkout', category: 'Checkout', ecommerceOnly: true},
            InitiatePurchase: {event: 'InitiatePurchase', label: 'Initiate Purchase', category: 'Checkout'},
            ModifyCart: {event: 'ModifyCart', label: 'Modify Cart', ecommerceEvent: null, category: 'Product', ecommerceOnly: false},
            MailingListSignup: {event: 'MailingListSignup', label: 'Mailing List Signup', category: 'Account'},
            PageLoaded: {event: 'PageLoaded', label: 'Page Loaded', category: 'Navigation'},
            Purchase: {event: 'Purchase', label: 'Purchase', category: 'Checkout'},
            PrintList: {event: 'PrintList', label: 'Print List', category: 'Print'},
            PrintResults: {event: 'PrintResults', label: 'Print Results', category: 'Print'},
            RemoveFromCart: {event: 'RemoveFromCart', ecommerceEvent: 'remove_from_cart', label: 'Remove From Cart', category: 'Product', ecommerceOnly: true},
            Search: {event: 'Search', event: 'search', label: 'Search', category: 'Navigation'},
            SelectContent: {event: 'SelectContent', ecommerceEvent: 'select_content', label: 'Products', category: 'Product', ecommerceOnly: true},
            StoreChanged: {event: 'StoreChanged', label: 'Store Changed', category: 'Store'},
            UserLogin: {event: 'UserLogin', label: 'User Login', category: 'Account'},
            UserRegistration: {event: 'UserRegistration', label: 'User Registration', category: 'Account'},
            ViewCart: {event: 'ViewCart', ecommerceEvent: 'view_cart', label: 'View Cart', category: 'Product', ecommerceOnly: true},
            ViewItemList: {event: 'ViewItemList', ecommerceEvent: 'view_item_list', label: 'Products', category: 'Product', ecommerceOnly: true},
            ViewContent: {event: 'ViewContent', ecommerceEvent: 'view_item', label: 'View Content', category: 'Product'},
            ViewSlider: {event: 'ViewSlider', ecommerceEvent: 'view_item_list', label: 'View Slider', category: 'Product'}
        }
        ,orderStatus: {
            OPEN: '1'
            ,USER_PLACED: '2'
            ,USER_CANCELED: '3'
            ,IN_PROGRESS: '4'
            ,FULFILLED: '5'
            ,READY_FOR_PICKUP: '6'
            ,USER_PICKED_UP: '7'
            ,WAITING_FOR_DELIVERY: '8'
            ,EN_ROUTE: '9'
            ,DELIVERED: '10'
            ,CLOSED: '11'
            ,CANCELED: '12'
            ,TRUE_UP_PAYMENT: '13'
        }
        ,orderItemStatusId: {
            OPEN: '1'
            ,FULFILLED: '2'
            ,FULFILLED_WITH_DIFFERENT_QUANTITY: '3'
            ,NOT_AVAILABLE: '5'
            ,FILLED_WITH_SUBSTITUTION: '7'
            ,ADDED_BY_STORE: '8'
            ,CANCELED: '9'
        }
        ,substitutionType: {
            NO_SUBSTITUTION: '1'
            ,BEST_COMPARABLE: '2'
        }
        ,fulfillmentType: {
            PICKUP: '1'
            ,DELIVERY: '2'
            ,DROP_SHIP: '3'
            ,DROP_OFF: '4'
        }
    };
})();